export const PREFIX_EVENTS_PRO_STORE = '@@MT/EVENTS-PRO';
